type RouteChangeCallback = (url: string) => void;

export type RouteObserver = {
  getUrl: () => string;
  subscribe: (cb: RouteChangeCallback) => void;
};

const createRouteObserver = (): RouteObserver => {
  let lastUrl = window.location.href;
  const subscribers: RouteChangeCallback[] = [];

  const notify = () => {
    // Routers call same-URL replaceState routinely (e.g. scroll restoration); those are not route changes and must not flush per-view metrics. Also keeps nested history wrappers from double-notifying.
    if (window.location.href === lastUrl) return;
    lastUrl = window.location.href;
    subscribers.forEach(cb => cb(lastUrl));
  };

  const patch = (method: 'pushState' | 'replaceState') => {
    const original = window.history[method].bind(window.history);
    // eslint-disable-next-line func-names
    window.history[method] = function (
      ...args: Parameters<typeof window.history.pushState>
    ) {
      original(...args);
      notify();
    };
  };

  patch('pushState');
  patch('replaceState');
  window.addEventListener('popstate', notify);

  return {
    // Read live so the URL stays correct even if a router later replaces the patched history methods (change notifications are best-effort).
    getUrl: () => window.location.href,
    subscribe: cb => {
      subscribers.push(cb);
    },
  };
};

export default createRouteObserver;
